import { translation as en } from './en.js';
import { translation as de } from './de.js';
export const languages = {
    // TODO: Translation type for en if translation finished
    en,
    de,
};
export const defaultLocale = 'de';
//# sourceMappingURL=defaultLocale.js.map